<template>
    <div style="margin-left: 10px; margin-right: 10px;">
      <button
       v-if="$canView('superadministrador','administradorevento')"
        @click="showModal = true"
        class="bg-green-600 hover:bg-green-700 text-white font-bold px-4 py-1 rounded "
      >
        {{ uiT('registration.button') }}
      </button>
      <!-- Modal de formulario -->
      <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-lg w-full max-w-lg relative">
          <button @click="closeAllModals" class="absolute top-2 right-2 text-gray-500 hover:text-black text-xl font-bold">×</button>
          <h2 class="text-xl font-bold mb-4">{{ uiT('registration.title') }}</h2>
          <form @submit.prevent="submitForm">
            <div class="mb-4">
              <label>{{ uiT('registration.name') }}</label>
              <input v-model="form.nombre" type="text" class="input-style" required>
            </div>
            <div class="mb-4">
              <label>{{ uiT('registration.email') }}</label>
              <input v-model="form.email" type="email" class="input-style" required>
            </div>
            <!-- Switch tipo Tailwind para representante legal -->
            <div class="mb-4 flex items-center gap-4">
              <label class="flex items-center cursor-pointer">
                <span class="mr-2 font-medium text-gray-700">{{ uiT('registration.legalRepresentative') }}</span>
                <div class="relative">
                  <input
                    type="checkbox"
                    v-model="esLegal"
                    class="sr-only peer"
                  />
                  <div class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-green-500 transition-colors"></div>
                  <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-full"></div>
                </div>
              </label>
            </div>
            <template v-if="esLegal">
              <div class="mb-4">
                <label>{{ uiT('registration.phone') }}</label>
                <input v-model="form.celular" type="text" class="input-style">
              </div>
              <div class="mb-4">
                <label>{{ uiT('registration.identification') }}</label>
                <input v-model="form.identificacion" type="text" class="input-style">
              </div>
              <div class="mb-4">
                <label>{{ uiT('registration.position') }}</label>
                <input v-model="form.cargo" type="text" class="input-style">
              </div>
            </template>
            <div class="flex justify-end gap-3 mt-5">
              <button type="button" @click="closeAllModals" class="px-4 py-2 bg-gray-400 text-white rounded">{{ uiT('common.cancel') }}</button>
              <button type="submit" class="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded">{{ uiT('registration.submit') }}</button>
            </div>
          </form>
        </div>
      </div>
      <!-- Modal QR con ticket acceso -->
      <div v-if="qrModalVisible" class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
        <div class="bg-white p-8 rounded-lg text-center max-w-md relative" style="display: flex; flex-direction: column; align-items: center;">
          <button @click="closeAllModals" class="absolute top-2 right-2 text-gray-500 hover:text-black text-xl font-bold">×</button>
          <h2 class="text-xl font-bold mb-4">{{ uiT('registration.qrTitle') }}</h2>
          <qrcode-vue :value="qrLink" :size="200" />
          <div v-if="tokenUser && idGroup" class="mt-4">
            <a
              :href="`/api/ticket/${tokenUser}/${idGroup}`"
              target="_blank"
              class="inline-block mt-2 px-4 py-2 bg-blue-600 hover:bg-blue-800 text-white rounded"
            >
              {{ uiT('moderators.accessTicket') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import QrcodeVue from 'qrcode.vue';
  import { userManagementI18nMixin } from "./i18n/userManagementI18n.js";
  
  export default {
    mixins: [userManagementI18nMixin],
    components: { QrcodeVue },
    props: {
      groupId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        showModal: false,
        qrModalVisible: false,
        qrLink: '',
        tokenUser: '',
        idGroup: '',
        esLegal: false,
        form: {
          nombre: '',
          email: '',
          celular: '',
          identificacion: '',
          cargo: ''
        }
      };
    },
    methods: {
      closeAllModals() {
        this.showModal = false;
        this.qrModalVisible = false;
        this.form = { nombre: '', email: '', celular: '', identificacion: '', cargo: '' };
        this.esLegal = false;
        this.qrLink = '';
        this.tokenUser = '';
        this.idGroup = '';
      },
      async submitForm() {
        try {
          const payload = {
            group_id: this.groupId,
            nombre: this.form.nombre,
            email: this.form.email,
            es_legal: this.esLegal ? 1 : 0,
            celular: this.esLegal ? this.form.celular : null,
            identificacion: this.esLegal ? this.form.identificacion : null,
            cargo: this.esLegal ? this.form.cargo : null
          };
          const res = await fetch('/api/grupo/registrar-usuario', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          const data = await res.json();
          if (res.ok && data.ok && data.link && data.token_user && data.id_group) {
            this.qrLink = data.link;
            this.tokenUser = data.token_user;
            this.idGroup = data.id_group;
            this.showModal = false;
            this.qrModalVisible = true;
            // this.$emit('user-registered');
            alert(this.uiT('registration.legalSuccess'));
          } else if (res.ok && data.ok) {
            alert(this.uiT('registration.success'));
            this.closeAllModals();
            // this.$emit('user-registered');
          } else {
            alert(data.error || this.uiT('registration.error'));
          }
        } catch (e) {
          alert(this.uiT('registration.connectionError'));
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .input-style {
    width: 100%;
    padding: 0 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  .peer:checked ~ .peer-checked\:translate-x-full {
    transform: translateX(100%);
  }
  </style>
  
